import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ArrowUpRightBlue,
  coachSignupCover,
  logo,
} from "../../constant/imagePath";
import { Button } from "../../stories/Button/Button";
import { Input } from "../../stories/Input/Input";
import classes from "./SignupCoachPage.module.css";
import { BeforeLoginHeader } from "../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { auth, authWithoutApp } from "../../firebase-config";
import errorMessage from "../../components/errorMessage";
import { isMobileViewHook } from "../../CustomHooks/isMobileViewHook";
import Fonts from "../../stories/assets/Fonts";
import Colors from "../../stories/assets/Colors";
import { LinkButtonWithIcon } from "../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { MobileHeader } from "../../stories/MobileHeader/MobileHeader";
import { PasswordStrengthCheck } from "../../stories/PasswordStrengthCheck/PasswordStrengthCheck";

import parsePhoneNumber, {AsYouType} from 'libphonenumber-js';
import { Post } from "../../Axios/AxiosFunctions";
import { apiHeader, BaseURL } from "../../Config/apiUrl";


const SignupCoachPage = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  // variables and states
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [retypePassword, setRetypePassword] = useState("");
  const [passValidation, setPassValidation] = useState(false);

  const [isMobile, setIsMobile] = useState(false);
  const signupUrl = BaseURL('coach/signup');

  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, [window.innerWidth]);

  const [loading, setLoading] = useState(false);

  const handleSignUpAction = async () => {
    try {
      setLoading(true);
      const response = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      HandleSubmitApi(response);
    } catch (error) {
      setLoading(false);
      const showErrorMessage = await errorMessage(error);
      toast.error(showErrorMessage);
    }
  };

  const HandleSubmitApi = async() => {
    setLoading(true);
    const Header = await apiHeader(false);
    const data = {
      "fullName": fullName,
      "email": email,
      ...(phoneNumber !== ""&&{"phoneNumber": phoneNumber}),
    };

    const response = await Post(signupUrl, data, Header);
    setLoading(false);
    if (response !== undefined) {
      toast.success(response.data?.message);
      history.push({
        state: email,
        pathname: `/check-your-email`,
      });
    }
  }

  return (
    <>
      <style jsx>{`
        .${classes.optional} {
          color: ${Colors.neutralShadesOfDimGray};
        }
      `}</style>
      <div className={classes.SignupCoachPage}>
        <div className={`container-fluid ${classes.container}`}>
          {isMobile ? (
            <MobileHeader
              isLogo={true}
              isAvatar={false}
              customStyle={{
                padding: "0px",
              }}
            />
          ) : (
            <BeforeLoginHeader
              onClick={() => {
                history.push({
                  pathname: "login",
                });
              }}
              icon={logo}
              text1={"Already have an account?"}
              text2={"Log in"}
              text1Style={{ color: Colors.neutralShadesOfDimGray }}
              goBackOnClick={() => history.goBack()}
            />
          )}

          <div className="row" style={{ height: "100%" }}>
            <div className="col-md-12">
              <div className="row">
                <div
                  className={`p-0 col-md-6 ${[
                    classes.imageContainer,
                    classes.innerContainer,
                  ].join(" ")}`}
                >
                  <img className="img-fluid d-block" src={coachSignupCover} />
                </div>
                <div
                  className={`p-5 col-md-6 ${[
                    classes.innerContainer,
                    classes.rightContainer,
                  ].join(" ")}`}
                >
                  <form
                    className={`col-md-12 ${[classes.formContainer].join(" ")}`}
                  >
                    <div className={classes.inputMb32}>
                      <Input
                        type={"email"}
                        label={"Email"}
                        state={email}
                        setter={setEmail}
                      />
                    </div>
                    <div className={classes.inputMb32}>
                      <Input
                        type={"text"}
                        label={"Full name"}
                        state={fullName}
                        setter={setFullName}
                      />
                    </div>
                    <div className={classes.inputMb32}>
                      <Input
                        type={"number"}
                        label={"Phone number"}
                        label2={
                          <span className={classes.optional}>(optional)</span>
                        }
                        state={phoneNumber}
                        setter={setphoneNumber}
                      />
                    </div>
                    <div className={classes.inputMb32}>
                      <Input
                        type={"password"}
                        label={"Password"}
                        state={password}
                        setter={setPassword}
                      />
                      <div className={classes.passwordStrength}>
                        <PasswordStrengthCheck
                          value={password}
                          setIsAllow={setPassValidation}
                        />
                      </div>
                    </div>
                    <div className={classes.inputMb32}>
                      <Input
                        type={"password"}
                        label={"Retype Password"}
                        state={retypePassword}
                        setter={setRetypePassword}
                      />
                    </div>
                    <div className={classes.btnMt32}>
                      <Button
                        primary={true}
                        size={"Large"}
                        label={loading ? "loading..." : "Sign up"}
                        disabled={loading ? true : false}
                        onClick={() => {
                          if (
                            email === "" ||
                            fullName === "" ||
                            password === "" ||
                            retypePassword === ""
                          ) {
                            return toast.error("Please fill all the fields");
                          } else if (!passValidation) {
                            return toast.warning(
                              "Password Validation Failed Please Enter Password As Per Given Instruction!"
                            );
                          }  else if (phoneNumber !== '') {
                            const checkNumber = parsePhoneNumber(phoneNumber, 'US');
                            if(checkNumber.isValid()){
                              return toast.warning(
                                "Enter Valid Phone Number"
                              );
                            }
                          }
                          handleSignUpAction();
                        }}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {/* Footer */}
            {/* Already have account Login for mobile  */}
            <div className={`col-sm-12 ${classes.footerContainer}`}>
              <div className={classes.alreadyHaveAccountForMobile}>
                <p
                  style={{
                    ...Fonts.p2,
                    color: Colors.neutralShadesOfDimGray,
                  }}
                >
                  Already have an account?
                </p>
                <LinkButtonWithIcon
                  primary={true}
                  text={"Log in"}
                  rightIcon={ArrowUpRightBlue}
                  iconStyle={{ margin: "0px" }}
                  onClick={() => history.push("/login")}
                />
              </div>
            </div>
            {/*  */}
          </div>
        </div>
      </div>
    </>
  );
};

export default SignupCoachPage;
